export enum UserManagementActionType {
  SET_USERS_DATA = 'SET_USERS_DATA',
  UPDATE_USER = 'UPDATE_USER',
  SET_VISUAL = 'SET_VISUAL',
  SET_AUTO_APPROVAL_STATE = 'SET_AUTO_APPROVAL_STATE',
}
